import { Checkbox, Col, Form, Input, notification, Row } from "antd";
import api from "../../services/api";
import { listagemActions, manutencaoActions } from "../../actions";
import { useStateValue } from "../../state";
import { useState } from "react";

export default function ManutencaoCstIbsCbs({ formulario, carregando, aoSalvar }) {

    const [{ ui, manutencao }, dispatch] = useStateValue();
    const [loading, setLoading] = useState(false);
    const [hover, setHover] = useState(false);
    const [fileList, setFileList] = useState([]);


    const salvarManutencao = (values) => {
        carregando(true);
        let retorno;

        let enderecoUrl = 'CstIbsCbs/';

        if (values.cst_id) {
            enderecoUrl += `Editar`;
            api.put(enderecoUrl, values).then(res => {
                if (res.status === 200) {
                    notification.success({ message: 'Operação concluída', description: "As novas configurações foram salvas com sucesso!" });
                    retorno = res.data;
                }
            }, err => {
                notification.error({ message: 'Erro ao processar a requisição.', description: JSON.stringify(err.response) });
            }).finally(
                () => {
                    atualizarPagina();
                    carregando(false);
                    aoSalvar(retorno);
                })
        } else {
            enderecoUrl += `Incluir`;
            api.post(enderecoUrl, values).then(res => {
                if (res.status === 200) {
                    notification.success({ message: 'Operação concluída', description: "As configurações foram incluidas com sucesso!" });
                    retorno = res.data;
                    dispatch({ type: manutencaoActions.CHANGE, data: { dados: res.data } });
                }
            }, err => {
                notification.error({ message: 'Erro ao processar a requisição.', description: JSON.stringify(err.response) });
            }).finally(
                () => {
                    atualizarPagina();
                    carregando(false);
                    aoSalvar(retorno);

                }
            );
        }
    }

    function atualizarPagina() {
        dispatch({ type: listagemActions.CHANGE, data: { ordem: '+cst_id' } });
    };

    return (
        <Form layout="vertical" form={formulario} name="CstIbsCbs" onFinish={salvarManutencao}>
            <Col xs={24} sm={24} md={13} lg={13} xl={13}>
                <Form.Item
                    name="cst_id"
                    label="CST do IBS/CBS"
                    rules={[{ required: true, message: 'Informe o código CST do IBS/CBS' }]}
                >
                    <Input placeholder="CST" />
                </Form.Item>

            </Col>
            <Col xs={24} sm={24} md={13} lg={13} xl={13}>
                <Form.Item label="Descrição" name="cst_descricao" rules={[{ required: true, message: 'Informe a Descrição do Cst de IBs/Cbs' },]}>
                    <Input placeholder="Informe a Descrição do Cst de IBs/Cbs" />
                </Form.Item>
            </Col>
            <Row align="middle" gutter={[8, 0]}>
                <Col>
                    <Form.Item name="cst_icmsdfe" initialValue={true} valuePropName="checked" className="t-mob-573">
                        <Checkbox>Permitido ICMS em DFe</Checkbox>
                    </Form.Item>
                </Col>
                <Col>
                    <Form.Item name="cst_indibscbs" initialValue={true} valuePropName="checked" className="t-mob-573">
                        <Checkbox>Indicador de IBS/CBS</Checkbox>
                    </Form.Item>
                </Col>
                <Col>
                    <Form.Item name="cst_ibscbsmonofasico" initialValue={true} valuePropName="checked" className="t-mob-573">
                        <Checkbox>Indicador de IBS/CBS Monofásico</Checkbox>
                    </Form.Item>
                </Col>
            </Row>
            <Row align="middle" gutter={[8, 0]}>
                <Col>
                    <Form.Item name="cst_ibscbsreducao" initialValue={true} valuePropName="checked" className="t-mob-573">
                        <Checkbox>Indicador de IBS/CBS com Redução</Checkbox>
                    </Form.Item>
                </Col>
                <Col>
                    <Form.Item name="cst_ibscbsdiferimento" initialValue={true} valuePropName="checked" className="t-mob-573">
                        <Checkbox>IndIcador de IBS/CBS com Diferimento</Checkbox>
                    </Form.Item>
                </Col>
                <Col>
                    <Form.Item name="cst_ibscbsregular" initialValue={true} valuePropName="checked" className="t-mob-573">
                        <Checkbox>Indicador de Tributação Regular</Checkbox>
                    </Form.Item>
                </Col>
            </Row>
        </Form >
    );
}